import React from 'react';
import PropTypes from 'prop-types';
import transform from 'lodash/transform';
import CustomStepCompletionCheckbox from 'components/trailmixes/CustomSteps/FormElements/CustomStepCompletionCheckbox';
import CustomStepDescriptionField from 'components/trailmixes/CustomSteps/FormElements/CustomStepDescriptionField';
import SelectComponent from 'components/form/SelectComponent';
import CustomStepTitleField from 'components/trailmixes/CustomSteps/FormElements/CustomStepTitleField';
import CustomStepTextInput from 'components/trailmixes/CustomSteps/FormElements/CustomStepTextInput';
import CustomStepEditIcon from 'components/trailmixes/CustomSteps/FormElements/CustomStepEditIcon';
import { buildScopeTranslate } from 'lib/I18n';

import { CUSTOM_STEP_LINK } from 'actions/trailmix_custom_steps_contants';

const tCustomStep = buildScopeTranslate('views.trailmixes.edit.custom_step_form');

export default function LinkForm({
  icon_type,
  icon_url,
  iconsMap,
  onChange,
  validationMessages,
  url,
  title,
  description,
  manual_completion,
  type,
}) {
  const linkicon_typeCollection =
    transform(iconsMap, (result, value, key) => result.push({
      name: value.name,
      value: key
    }), []);

  const handleTypeChange = (event) => {
    const newType = event.target.value;
    onChange('icon_type', newType);
    onChange('icon_url', iconsMap[newType].icon_url);
  };

  return (
    <div className="slds-size_5-of-5">
      <CustomStepTextInput
        id={tCustomStep('url')}
        value={url}
        type="url"
        title={tCustomStep('url')}
        onChange={(evt) => onChange('url', evt.target.value)}
        required={true}
        validationMessages={validationMessages.url}
        placeholder={tCustomStep('url_placeholder')}
      />

      {
        type === CUSTOM_STEP_LINK &&
        <CustomStepEditIcon
          label={tCustomStep('icon')}
          iconUrl={icon_url}
          modifier="link"
        >
          <SelectComponent
            id={tCustomStep('icon')}
            collection={linkicon_typeCollection}
            selectedValue={icon_type}
            onChange={handleTypeChange}
          />
        </CustomStepEditIcon>
      }

      <CustomStepTitleField
        id="custom-step-title"
        value={title}
        onChange={onChange}
        required={true}
        placeholder={tCustomStep('title_placeholder')}
        validationMessages={validationMessages.title}
      />

      <CustomStepDescriptionField
        value={description}
        onChange={onChange}
        required={true}
        placeholder={tCustomStep('description_placeholder')}
        validationMessages={validationMessages.description}
      />

      <CustomStepCompletionCheckbox value={manual_completion} onChange={onChange} />

    </div>
  );
}

LinkForm.propTypes = {
  icon_type: PropTypes.string,
  icon_url: PropTypes.string,
  iconsMap: PropTypes.object,
  onChange: PropTypes.func,
  validationMessages: PropTypes.object,
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  manual_completion: PropTypes.bool,
  type: PropTypes.string,
};
